import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { AdminCloseIcon, AdminRightArrowIcon, RecognitionTickIcon, ReportIcon } from '../../utils/icons';
import { RecognitionWarningIcon } from '../../utils/icons';
import { BorderV1, Button, CalendarHeader, RadioButtonWrapper, ReportContainer, StyledModalV1 } from './styles';
import { ManagerIconContainer } from '../Manager/styles';
import { toast } from 'react-toastify';
import { fetchApi } from '../../utils/methods';
import { GetFlagReasons, SubmitFlaggedPost } from '../../redux/constants/apiConstants';
import ToastMessage from '../Manager/ToastMessage';

const ReportPostPopup = ({ show, onClose,postId, getFeedHighlights }) => {
  const [page, setPage] = useState(1);
  const [flaggedReasons, setFlaggedReasons] = useState();
  const [selectedOption, setSelectedOption] = useState();
  const [selected, setSelected] = useState(false);

  const handleToggle = () => {
    setSelected(!selected);
  };

  const handleOptionChange = (value) => {
    setSelectedOption(value);
  };

  const handleNext = () => {
    setPage(2);
  }

  const handleClose = () => {
    onClose()
  }

  useEffect(() => {
    fetchFlaggedReasonsData();
  }, []);

  const fetchFlaggedReasonsData = async () => {
    const apiUrl = `${GetFlagReasons}`;
    try {
      const res = await fetchApi(apiUrl, "GET");
      if (res.status === "success") {
        setFlaggedReasons(res.data);
      } else {
        toast.error(res.message);
      }
    } catch (error) {
      window.console.error(error);
    }
  };


  const reportPost = async (payload)=>{
    const postData = {
      ...payload
    };
    try{
      const res = await fetchApi(SubmitFlaggedPost,"POST",postData );
      if (res.data.message) {
        toast.error(res.data.message);
      } else {
        toast(
          <ToastMessage
            title="Successfully Reported"
            message="Thanks for reporting this post.Your feedback is important in helping us keep the Woliba community safe."
          />,
          {
            position: "top-right",
            autoClose: 3000, 
            closeButton: false, 
            hideProgressBar: true,
            pauseOnHover: true,
            draggable: true,
            zIndex:900000,
            style: {
              right: "165px", 
              top: "46px", 
              marginRight:'20px',
              backgroundColor: "transparent", 
              boxShadow: "none", 
              width:'510px',
            },
          },
        );
        getFeedHighlights();
      }
         

    }catch(error){
    // toast.error(error)
    }

  }


  const handleReport = () => {
    let reportDetails ={
      post_id: postId,
      flagged_reason_id:selectedOption ,
      is_anonymous:selected , 
    }
    reportPost(reportDetails);
    handleClose();
    
  }

  return (

    <StyledModalV1 show={show} width={"400px"} height={"500px"}>
      <div className="modal-content-padding">
        <CalendarHeader>
          <div className="left-content">
            <ManagerIconContainer>{RecognitionWarningIcon("#8391D1")}</ManagerIconContainer>
            <div>Report a Post</div>
          </div>
          <ManagerIconContainer className="close-icon" onClick={onClose}>
            {AdminCloseIcon()}
          </ManagerIconContainer>
        </CalendarHeader>
        <BorderV1 />
        {page === 1 &&
          (<ReportContainer>
            <div className="reportHeading"> Why are you reporting this post?</div>
            <div className="reportText">
              Select a reason to help us address any issues and improve the community experience.
            </div>
            <label className="archive-container">
              <input
                type="checkbox"
                checked={selected}
                onChange={handleToggle}
                style={{ display: "none" }}
              />
              <div className={`archive-action ${selected ? "selected" : ""}`}>
                {selected && RecognitionTickIcon()}
              </div>
              <span className="archive-label">Report anonymously</span> {/* Label name here */}
            </label>
            <BorderV1 />
            <RadioButtonWrapper>
              {flaggedReasons?.map((item, index) => (
                <div className="RadioButtonContainer" key={index}>
                  <input className="RadioButton"
                    type="radio"
                    name="option"
                    checked={selectedOption === item.id}
                    onChange={() => handleOptionChange(item.id)}
                  />
                  <div className="label">{item.reason}</div>
                </div>))}
            </RadioButtonWrapper>
            <Button
              isWidth="100%"
              isHeight="40px"
              background="#F37A65"
              isFont="16px"
              color="white"
              backgroundHover="#EA6149"
              disabled={!selectedOption}
              onClick={!selectedOption ?  null : handleNext }
            >
              <div className="btn-text">Next</div>
              <ManagerIconContainer isWidth="16px" isHeight="16px">{!selectedOption ? AdminRightArrowIcon("#989898") : AdminRightArrowIcon("white")}</ManagerIconContainer>
            </Button>
          </ReportContainer>)}
        {
          page === 2 && (
            <ReportContainer isAlign="center" isMargin="0px">
              <div className="reportText reportTextTop">Are you sure you want to report this post?</div>
              <div className="reportText reportTextBottom">Our team will review the content based on your <br></br> feedback.</div>
              <div className="buttonContainer">
                <Button
                  isWidth="112px"
                  isFont="16px"
                  isHeight="40px"
                  background="white"
                  color="#184A61"
                  backgroundHover="white"
                  colorHover="#F37A65"
                  isMargin="20px auto opx auto"
                  onClick={handleClose}
                >
                  Keep Post
                </Button>
                <Button
                  isWidth="112px"
                  isFont="16px"
                  isHeight="40px"
                  background="#F37A65"
                  color="white"
                  backgroundHover="#EA6149"
                  onClick={handleReport}
                  isMargin="20px auto opx auto"
                ><ManagerIconContainer>{ReportIcon()}</ManagerIconContainer><div className="btn-text">Report</div></Button>
              </div>
            </ReportContainer>)
        }
      </div>
    </StyledModalV1>
  );
};

ReportPostPopup.propTypes = {
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  icon: PropTypes.node.isRequired,
  postId:PropTypes.number.isRequired,
  getFeedHighlights:PropTypes.func
};



export default ReportPostPopup;
